import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from '../config';
import { StorageService } from '../../managers/storage.service';
import { Messages } from '../../../model/messages';

@Injectable({
  providedIn: 'root'
})
export class MessagesService extends Config {

  constructor(private httpClient: HttpClient,
    private storageService: StorageService) {

    super();

  }

  public sendMessage(msg: any){
    var url;

    url = this.BASE_URL + "messages_send";

    return this.httpClient.post(url, msg, this.storageService.getHeaders());
  }

  public sendNewMessage(msg: any){
    var url;

    url = this.BASE_URL + "new_message_send";

    return this.httpClient.post(url, msg, this.storageService.getHeaders());
  }

  public createMessage(message: Messages) {
    var url;

    url = this.BASE_URL + "messages_create";

    return this.httpClient.post(url, message, this.storageService.getHeaders());
  }

  public getMessages(conversationID: number, page: number,
    maxItemPerPage: number) {

    var url;
    var request;

    url = this.BASE_URL + "messages_get";

    request = {
      'maxItemPerPage': maxItemPerPage,
      'conversation_id': conversationID,
      'page': page,
    }

    return this.httpClient.post(url, request, this.storageService.getHeaders());

  }

  public getRecentMessage(conversationID: number) {
    var url;

    url = this.BASE_URL + "messages_get_recent?conversation_id=" + conversationID;

    return this.httpClient.get(url, this.storageService.getHeaders());
  }

  public getCountAllMessages(userID: number,filterType: string) {
    var url;
    let isAdmin;

    // isAdmin = this.storageService.isAdmin();
    isAdmin = true;

    url = this.BASE_URL + "messages_count?userID=" + userID + '&filter_type=' + filterType ;

    return this.httpClient.get(url, this.storageService.getHeaders());
  }
}
